import {identityConst} from '../../conf';

/**
 * 拓扑插件-左侧边栏模块数据
 *
 * id: 唯一标识
 * parentId: 父级元素ID
 * elementName：元素名称
 * elementIdentity: 元素标识
 * showStatus：显示状态（0隐藏、1显示 ）
 * iconType：模块图标类型（0使用字体图标、1使用图片URL）
 * iconContent：字体图标class名或图片路径
 */
export const moduleArray = [
  {
    id: '1603680086333083650',
    parentId: '0',
    elementName: '组件信息',
    elementIdentity: identityConst.componentInfo,
    showStatus: 1,
    iconType: 0,
    iconContent: 'le-tab-icon lt tp-icon-zu-jian-fill'
  },
  {
    id: '1604678703101632540',
    elementName: '常规图形',
    elementIdentity: identityConst.generalGraphics,
    showStatus: 1,
    iconType: 0,
    iconContent: 'le-tab-icon lt tp-icon-tu-xing-fill'
  },
  {
    id: '1604679653627297800',
    elementName: '图片素材',
    elementIdentity: identityConst.pictureMaterial,
    showStatus: 1,
    iconType: 0,
    iconContent: 'le-tab-icon lt tp-icon-tu-pian-fill'
  },
  {
    id: '1604680216876187680',
    elementName: '文字素材',
    elementIdentity: identityConst.textMaterial,
    showStatus: 1,
    iconType: 0,
    iconContent: 'le-tab-icon lt tp-icon-wen-zi-fill'
  },
  {
    id: '1604680629197217800',
    elementName: '背景图片',
    elementIdentity: identityConst.backgroundPicture,
    showStatus: 1,
    iconType: 0,
    iconContent: 'le-tab-icon lt tp-icon-bei-jing-fill'
  }
];
